import { render, staticRenderFns } from "./SmsManager.vue?vue&type=template&id=5a8568f7&"
import script from "./SmsManager.vue?vue&type=script&lang=ts&"
export * from "./SmsManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports